import { DropdownButton, MenuItem } from 'react-bootstrap';
import type { VoidFunctionComponent } from 'react';

import { OrganizationSsoMethod } from '../../../../../../typings/enums';
import Text from '../../../../generic/Text';

type AuthenticationMethodPickerProps = {
  method: OrganizationSsoMethod;
  onSelectMethod: (method: OrganizationSsoMethod) => Promise<void>;
};

const methodsToLabelMap: Record<OrganizationSsoMethod, string> = {
  [OrganizationSsoMethod.Google]: 'Google Workspace (G Suite)',
  [OrganizationSsoMethod.SAML]: 'SAML',
  [OrganizationSsoMethod.LDAP]: 'LDAP',
};

/**
 * If the user is using SSO/SSO+Email, this will be displayed.
 */
const AuthenticationMethodPicker: VoidFunctionComponent<AuthenticationMethodPickerProps> = ({
  method: selectedMethod,
  onSelectMethod,
}) => {
  return (
    <div className="margin-top-lg margin-bottom-lg">
      <Text.H4>SSO Method</Text.H4>
      <DropdownButton id="sso-method-picker" title={methodsToLabelMap[selectedMethod]}>
        {Object.entries(methodsToLabelMap).map(([method, label]) => (
          <MenuItem key={method} onSelect={() => onSelectMethod(method as OrganizationSsoMethod)}>
            {label}
          </MenuItem>
        ))}
      </DropdownButton>
    </div>
  );
};

export default AuthenticationMethodPicker;
